/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React, { useEffect, useState, useRef } from 'react'
import PropTypes, { arrayOf, shape } from 'prop-types'
import ShutterList from 'components/ShutterList'
import PathwaysHeader from 'components/PathwaysHeader'
import PathwayCard from 'components/PathwayCard'
import { PageWrapper } from 'components/ShutterList/component.styles'
import { StyledBackgroundImage } from './component.styles'
import { isPreviewMode } from 'utils/highschoolHelpers'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContextLegacy'

const PathwayPage = props => {
  const [courseDisplayTitle, setCourseDisplayTitle] = useState()
  const [courseDescription, setCourseDescription] = useState()
  const selectRef = useRef()

  const [pageDisplayTitle, setPageDisplayTitle] = useState()
  const [pageDescription, setPageDescription] = useState()
  const [pageImage, setPageImage] = useState()

  const [collection, setCollection] = useState()
  const [tabs, setTabs] = useState()

  const { content, handleTabChange } = props
  const queryParamsString = window?.location?.search || ''

  useEffect(() => {
    if (!content) {
      return
    }

    const { navigationPage = {} } = content
    const {
      courseSummary,
      pageSummary,
      linkSummaries,
      tabSummaries,
    } = navigationPage

    if (courseSummary) {
      const { displayTitle, description } = courseSummary
      if (displayTitle) setCourseDisplayTitle(displayTitle)
      if (description) setCourseDescription(description)
    }

    if (pageSummary) {
      const { displayTitle, description, image } = pageSummary
      if (displayTitle) setPageDisplayTitle(displayTitle)
      if (description) setPageDescription(description)
      if (image) setPageImage(image)
    }

    if (linkSummaries) {
      setCollection(linkSummaries)
    }

    if (tabSummaries) {
      setTabs(tabSummaries)
    }
  }, [content])

  const hasFooter = !!pageImage

  const tabDescription = {
    body: pageDescription ?? '',
    title: pageDisplayTitle ?? '',
    hasFooter,
    footerChildren: hasFooter && <StyledBackgroundImage src={pageImage?.url} />,
  }

  // Transform the data to match Pathways props
  const pathways =
    tabs?.map(tab => ({
      id: tab?.internalTitle || tab?.displayTitle,
      title: tab?.displayTitle,
      description: tab?.description,
    })) || []

  const activePathway = tabs?.find(t =>
    window.location.pathname.endsWith(t?.route),
  )
    ? {
        id:
          tabs?.find(t => window.location.pathname.endsWith(t?.route))
            ?.internalTitle ||
          tabs?.find(t => window.location.pathname.endsWith(t?.route))
            ?.displayTitle,
        title: tabs?.find(t => window.location.pathname.endsWith(t?.route))
          ?.displayTitle,
        description: tabs?.find(t =>
          window.location.pathname.endsWith(t?.route),
        )?.description,
      }
    : null

  const items =
    collection?.map(item => ({
      title: item?.displayTitle,
      description: item?.description,
      path: item?.route,
    })) || []

  const renderItem = item => (
    <PathwayCard
      description={item?.description}
      isPreview={item?.isPreview}
      path={`${item?.path}${queryParamsString}`}
      title={item?.title}
    />
  )

  const onPathwayChange = pathway => {
    const originalTab = tabs?.find(tab => tab?.displayTitle === pathway?.title)
    handleTabChange(originalTab)
  }

  // Page-level logic
  const pageTitles = {
    page: 'Second Step',
    pathway: activePathway?.title,
  }

  useEffect(() => {
    if (pageTitles?.pathway) {
      document.title = `${pageTitles?.page} | ${pageTitles.pathway}`
    }
  }, [pageTitles.pathway])

  return (
    <PageWrapper>
      <PathwaysHeader
        activePathway={activePathway}
        breadcrumb={content?.navigationPage?.breadcrumb}
        currentPageTitle={pageDisplayTitle || activePathway?.title}
        dataTestId="pathway"
        description={courseDescription}
        handleOnPathwayChange={onPathwayChange}
        isPreview={isPreviewMode()}
        onPathwayChange={onPathwayChange}
        pathwayTitle={activePathway?.title}
        pathways={pathways}
        selectRef={selectRef}
        showPreviewBanner={true}
        showSiteSelector={true}
        title={courseDisplayTitle}
      />
      <ShutterList
        contentDescription={tabDescription}
        items={items}
        renderItem={renderItem}
      />
    </PageWrapper>
  )
}

const summary = shape({
  description: PropTypes.string.isRequired,
  displayTitle: PropTypes.string.isRequired,
  image: shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
})

PathwayPage.propTypes = {
  content: PropTypes.shape({
    navigationPage: shape({
      courseSummary: summary,
      pageSummary: summary,
      tabSummaries: arrayOf(summary),
      linkSummaries: arrayOf(summary),
    }).isRequired,
  }),
  handleTabChange: PropTypes.func,
  match: PropTypes.shape({
    url: PropTypes.string,
    search: PropTypes.string,
    params: PropTypes.object,
  }),
}

export default withSiteContext(PathwayPage, {
  useGuard: true,
})
